import { render, staticRenderFns } from "./PrivilegeDialog.vue?vue&type=template&id=4565040e&"
import script from "./PrivilegeDialog.vue?vue&type=script&lang=js&"
export * from "./PrivilegeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports